<template>
    <v-col :cols="cols">
        <v-select
            v-model="selected"
            :items="items"
            :label="$t('lang_GENERIC_CAPTION_SELECT_ACTION')"
            @input="doAction"
            menu-props="offset-y, offset-overflow"
            hide-details
            clearable
            :alvqa="alvqa + '-list-action-dropdown'"
            :no-data-text="$t('lang_GENERAL_CAPTION_NO_DATA_AVAILABLE')"
            @click:clear="resetVal()"
        >
            <template v-slot:item="{ item }">
                <div :alvqa="item.alvqa">
                    {{ item.text }}
                </div>
            </template>
            <template v-slot:selection="{ item }">
                <div class="text-no-wrap text-truncate" :alvqa="item.alvqa">
                    {{ item.text }}
                </div>
            </template>
        </v-select>
    </v-col>
</template>

<script>
import VSelect from 'vuetify/es5/components/VSelect'

export default {
    name: "ActionDropdown",
    extends: VSelect,
    props: {
        context: String,
        alvqa: {
            type: String,
            default: ''
        },
        cols: {
            type: String,
            default: "3"
        }
    },
    computed: {
        selected: {
            get() { return this.$store.getters['getSelected'+this.context+'Action'] },
            set(selectedAction) { this.$store.commit('setSelected'+this.context+'Action', selectedAction) }            
        },
    },
    methods: {
        doAction() {
            if(this.selected !== null) {

                // Mixpanel tracking
                let action = 'Action > ' + this.selected.charAt(0).toUpperCase() + this.selected.slice(1)
                let entities = this.$store.getters['getSelected'+this.context]
                mixpanel.track(action , {
                    'entityIds': entities,
                    'routePath': this.$route.path,
                    'userId': this.$store.getters.getUser.id,
                });

                if(this.$store._actions['do'+this.context+'Action']){
                    this.$store.dispatch('do'+this.context+'Action')
                }
                // fix due to Vuetify breaking change in dropdowns (to further use which action was selected)
                if(this.$store._mutations['setSelected' + this.context+'Action']) {
                    if(this.selected !== 'archiveWithForwarded' && this.selected !== 'archiveWithoutForwarded') {
                        this.$store.commit('setSelected' + this.context+'Action' , [])
                    }
                }
            }
        },
        async resetVal() {
            await this.$nextTick()
            this.selected = null
        }
    }
}
</script>